<template>
  <div class="modal-window uts016 sec">
    <header class="modal-header">
      <div class="tit">{{$i18nUtil.trans("title.TodoAddModal.001","할 일 추가하기")}}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="input-box">
        <textarea
          name=""
          id=""
          maxlength="101"
          :placeholder="this.$i18nUtil.trans('message.TodoAddModal.002','할 일을 입력해주세요.')"
          v-model="todoInfo.todoTitle"
          @input="errorTitle = false"
        ></textarea>
        <div class="error" v-if="errorTitle">{{$i18nUtil.trans("message.TodoAddModal.003","할 일 내용을 입력해주세요.")}}</div>
        <div
          class="error"
          v-if="
            todoInfo.todoTitle.length != '' && todoInfo.todoTitle.length > 100
          "
        >
          {{ $i18nUtil.trans("message.TodoAddModal.004","입력글자를 초과하였습니다.") }} (<b>{{ todoInfo.todoTitle.length }}</b
          >/100)
        </div>
      </div>

      <ul class="list-table">
        <li style="display:none;">
          <dl>
            <dt>{{ $i18nUtil.trans("entity.todo.requester","요청자") }}</dt>
            <dd>
              <form action="" onsubmit="return false;" novalidate>
                <div class="search_ty1">
                  <input
                    type="text"
                    required
                    v-model="regUserName"
                    :placeholder="$i18nUtil.trans('message.placeholder.nameEmail','이름 또는 이메일로 검색')"
                    @input="searchByKeyword1"
                  />
                  <button
                    type="reset"
                    class="btn_search"
                    @click="
                      regUserName = '';
                      isSearch1 = false;
                    "
                  >
                    검색
                  </button>
                  <div class="list scroll" v-if="isSearch1">
                    <div class="nodata" v-if="userList1.length == 0" v-html="$i18nUtil.trans('message.TodoAddModal.005','해당 검색어와 일치하는 사용자가 없습니다.')">
                    </div>
                    <ul class="membersearchlist">
                      <li
                        style="cursor:pointer"
                        v-for="(member, index) in userList1"
                        :key="index"
                        :data-user-id="member.userId"
                        @click="todoAddregUser(member)"
                      >
                        <div
                          class="img user-photo"
                          :data-user-id="member.userId"
                        >
                          <img src="@/assets/img/no-avatar.png" alt="" />
                        </div>
                        <b
                          >{{ member.userName }}&nbsp;<span>{{
                            member.positionName
                          }}</span></b
                        >
                        <span class="mail ell-singleline"
                          >{{ member.companyName }} /
                          {{
                            member.isExternalUser
                              ? member.partnerName
                              : member.deptName
                          }}</span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="error" v-if="errorReg">
                  {{ $i18nUtil.trans("message.TodoAddModal.006","요청자를 지정해주세요.") }}
                </div>
              </form>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("entity.todo.personInCharge","담당자") }}</dt>
            <dd>
              <div class="dropdown ty1">
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="search_ty1">
					           <v-row v-resize="onResize">
                      <input
                        type="text"
                        required
                        style="border: none; background-color: #fff; padding: 0px; color:#000;"
						            :style="{ width: resizeWidth + 'px' }"
                        disabled="disabled"
                        :value="regUserName"
                      />
					          </v-row>
                      <v-btn v-bind="attrs" v-on="on" class="btn_search" style="right: 0px !important; background-position: -120px 0;" 
                        @click="todoTargetInput=''; isSearch=false;"
                      ></v-btn>
                      <!-- @click="clickMemberSearchBtn" -->
                    </div>
                  </template>
                  <div class="dropdown-list">
                    <div class="member-call-box search" style="padding: 0px; height:250px;">
                      <form action="" onsubmit="return false;" novalidate>
                        <div class="search_ty1">
                          <input
                            type="text"
                            :placeholder="this.todoTarget"
                            @input="searchByKeyword"
                            v-model="todoTargetInput"
                          />
                          <button type="reset" class="btn_search">검색</button>
                          <div class="list scroll" style="height:174px; display: block;">
                            <div class="nodata" v-if="!isSearch" v-html="$i18nUtil.trans('message.TodoAddModal.007','담당자를 지정하여 할 일을 할당해보세요.')"></div>
                            <div class="nodata" v-if="isSearch && userList.length == 0" v-html="$i18nUtil.trans('message.TodoAddModal.005','해당 검색어와 일치하는 사용자가 없습니다.')">
                            </div>
                            <ul class="membersearchlist" style="height:auto;" v-if="isSearch && userList.length > 0">
                              <li
                                style="cursor:pointer"
                                v-for="member in userList"
                                :key="member.userId"
                                :data-user-id="member.userId"
                                @click="fnTodoAddMember(member)"
                              >
                                <div
                                  class="img user-photo"
                                  :data-user-id="member.userId"
                                >
                                  <img src="@/assets/img/no-avatar.png" alt="" />
                                </div>
                                <b
                                  >{{ member.userName }}&nbsp;<span>{{
                                    member.positionName
                                  }}</span></b
                                >
                                <span class="mail ell-singleline"
                                  >{{ member.companyName }} /
                                  {{
                                    member.isExternalUser
                                      ? member.partnerName
                                      : member.deptName
                                  }}</span
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </v-menu>
              </div>
              <div class="member_grp" v-if="todoInfo.members.length > 0">
                <div class="scroll" style="height: 33px;">
                  <div
                    v-for="member in todoInfo.members"
                    :key="member.userId"
                    :data-user-id="member.userId"
                  >
                    {{ member.userName }}
                    <button type="button" @click="fnTodoDelMember">x</button>
                  </div>
                </div>
              </div>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("entity.todo.period","기간") }}</dt>
            <dd>
              <!-- <div class="calendar_box_grp"> -->
              <div class="calendar_box">
                <datepicker 
                  format="yyyy.MM.dd"
                  v-model="todoInfo.startDate"
                  v-on:input="fnTodoStartUpdatedate"
                ></datepicker>
              </div>
              <span>~</span>
              <div class="calendar_box">
                <datepicker 
                  format="yyyy.MM.dd" 
                  v-model="todoInfo.endDate"
                  v-on:input="fnTodoEndUpdatedate" 
                  :disabled-dates="endDisabledDate"
                ></datepicker>
              </div>
              <!-- </div> -->
              <!-- <div class="calendar_box">
                <datepicker
                  format="yyyy.MM.dd"
                  :value="date"
                  locale="ko-KR"
                  v-on:input="fnTodoUpdatedate"
                  :disabled-dates="disabledDate"
                ></datepicker>
              </div> -->
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("message.TodoAddModal.012","업무보드 연결") }}</dt>
            <dd>
              <button type="button" class="btn_link_add" v-if="linkList.length == 0" @click="linkedModalOpen()">{{ $i18nUtil.trans("button.paper.connect","보드 연결") }}</button>
              <button type="button" class="btn_link_add" v-else @click="linkedModalOpen()">{{ $i18nUtil.trans("button.paper.changeConn","보드 연결 변경") }}</button>
              <div class="board_add_box">
                <div class="nodata" v-if="linkList.length == 0">
                  <div class="txt">{{ $i18nUtil.trans("message.TodoAddModal.008","업무보드를 연결하세요.") }}</div>
                </div>
                <div class="board" v-if="linkList.length > 0">
                  <!-- <div class="top">
                    <span>{{ linkList[0].kbnName }}</span>
                    <span v-if="linkList[0].paperId != ''" class="dividing_line_ty3"></span>
                    <span v-if="linkList[0].paperId != ''">{{ linkList[0].categoryName }}</span>
                    <span v-if="linkList.length > 0" class="dividing_line_ty3"></span>
                    <button v-if="linkList.length > 0" type="button" class="btn-more-ico_small3" @click="linkedListModalOpen">
                      <span class="num">
                        <b v-if="linkList.length > 99">99+</b>
                        <b v-else>{{ linkList.length }}</b>
                        건</span> 더보기
                    </button>
                  </div> -->
                  <div class="btm">
                    <div class="tit ell-singleline">{{ linkList[0].paperTitle }}</div>
                    <div class="btn-connect_wrap">
                        <button type="button" @click="removeLinkConfirm(linkList[0].targetId)">{{ $i18nUtil.trans("button.terminateConn","연결 해제") }}</button>
                    </div>
                  </div>
                  <!-- <button v-if="linkList.length > 0" type="button" class="btn-more-ico_small3" @click="linkedListModalOpen">
                    <span class="num">
                      <b v-if="linkList.length > 99">99+</b>
                      <b v-else>{{ linkList.length }}</b>
                      건</span> 더보기
                  </button> -->
                </div>
              </div>
            </dd>
          </dl>
        </li>
      </ul>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="fnTodoRegister">
        {{ $i18nUtil.trans("button.register","등록") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import TodoLinkedModal from "./TodoLinkedModal.vue";
import TodoLinkedListModal from "./TodoLinkedListModal.vue";
import EventBus from "@/js/eventbus/eventBus";

export default {
  components: {
    Datepicker,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),
      todoInfo: {
        members: [],
        todoTitle: "",
        startDate: new Date(this.$moment().format("YYYY-MM-DD")), // new Date(this.$moment())로 생성시 axios post 통신시 date type > gmt 시간으로 변경되어 (.format("YYYY-MM-DD") 붙여줌)
        endDate: new Date(this.$moment().format("YYYY-MM-DD")), // new Date(this.$moment())로 생성시 axios post 통신시 date type > gmt 시간으로 변경되어 (.format("YYYY-MM-DD") 붙여줌)
        delReason: "",
        todoMain: null,
        todoList: null,
        todoRegUser: this.modalInfo.userInfo.userId,
      },
      members: [],
      linkList: [],
      data: {
        obj: this,
        url: null,
        header: null,
        sendType: null,
        frm: null,
      },
      isSearch: false,
      isSearch1: false,
      searchFlag: false,
      userInfo: this.modalInfo.userInfo,
      items: [],
      userList: [],
      userList1: [],
      regUserName: this.modalInfo.userInfo.userName,
      resizeWidth: 0, // 담당자 Input 사이즈 조절
      todoTargetInput: '',
      todoTarget: this.$i18nUtil.trans("message.placeholder.nameEmail","이름 또는 이메일로 검색"),
      forMe: false,
      errorTitle: false,
      errorReg: false,
      errorTarget: false,
      date: new Date(),
      /**
       * 2021.04.07 시작일 전체 선택 가능하도록 요청사항
      startDisabledDate: {
        to: new Date(this.$moment().subtract(1, "days")),
        from: new Date(this.$moment().subtract(0, "days"))
      },
      */
      endDisabledDate: {
        //to: new Date(this.$moment().subtract(1, "days"))
      },
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  mounted() {
    this.linkList = [];
    this.setDisabledDate();
  },
  watch: {
    regUserName() {
      this.errorReg = false;
      if(this.regUserName === null ||
        this.regUserName === '') {
          this.todoInfo.todoRegUser = null;
        }
    }
  },
  created() {
    const self = this;
    $("html").click(function (e) {
      if (!$(e.target).hasClass("list scroll")) {
        self.isSearch = false;
        self.isSearch1 = false;
      }
    });
    EventBus.$on("setAddTodoLink", (payload) => {
      this.linkList = [];
      this.linkList.push(payload);
    });
    EventBus.$on("main_TodoAddModal_linkedModalOpen", (payload) => {
      this.linkedModalOpen();
    });
    EventBus.$on("main_TodoAddModal_removeLink", (payload) => {
      this.removeLink(payload);
    });
  },
  updated() {
    this.updateUserPhoto();
  },
  methods: {
    ...mapActions("modals", ["showToast", "showModal"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO"]),

    fnTodoDelMember(e) {
      if (!this.forMe) {
        let parent = e.target.parentNode;
        let userId = parent.getAttribute("data-user-id");
        let members = this.todoInfo.members;
        for (let inx = 0; inx < members.length; inx++) {
          if (members[inx].userId == userId) {
            members.splice(inx, 1);
            break;
          }
        }
      }
    },
    fnTodoStartUpdatedate(event) {
      this.todoInfo.startDate = event;
      let startDay = this.todoInfo.startDate;
      let endDay = this.todoInfo.endDate;
      if (startDay > endDay) {
        this.todoInfo.endDate = startDay;
      }
      this.setDisabledDate();
    },
    fnTodoEndUpdatedate(event) {
      this.todoInfo.endDate = event;
      this.setDisabledDate();
    },
    setDisabledDate() {
      //this.startDisabledDate.from = this.todoInfo.endDate; //2021.04.07 시작 전체 선택 가능하도록 요청사항
      this.endDisabledDate.to = this.todoInfo.startDate;
    },
    fnTodoRegister() {
      let self = this;
      if (
        self.todoInfo.endDate === null ||
        self.todoInfo.endDate === undefined
      ) {
        this.showAlertDialog(this.$i18nUtil.trans("message.TodoAddModal.009","종료일을 입력해주세요."), null, {
          width: "440px",
          height: "160px",
        });
        return;
      }
      if (
        self.todoInfo.todoTitle === null ||
        self.todoInfo.todoTitle === "" ||
        self.todoInfo.todoTitle === undefined
      ) {
        this.errorTitle = true;
        return;
      }

      if (
        self.todoInfo.todoRegUser === null ||
        self.todoInfo.todoRegUser === undefined
      ) {
        this.errorReg = true;
        return;
      }
      // if (
      //   self.todoInfo.members === [] ||
      //   self.todoInfo.members === [{}] ||
      //   self.todoInfo.members.length == 0 ||
      //   self.todoInfo.members === undefined
      // ) {
      //   this.errorTarget = true;
      //   return;
      // }
      let param = self.todoInfo;
      param.linkList = self.linkList;

      //프로그레스바 시작
      this.showLoadingbar();
      /* 할 일등록 */
      self.$axios
        .post("/api/copaper/todo/todoInsertFree", param)
        .then((res) => {
          this.hideLoadingbar();
          let msg = this.$i18nUtil.trans("message.TodoAddModal.011","할 일이 등록되었습니다.");
          self.toastInfo.message = msg;
          self.showToast(self.toastInfo);
          EventBus.$emit("refreshTodoNewPage");
          this.$emit("close");
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    fnTodoInvolvedUser() {
      let todoList = this.todoInfo.todoList;
      for (let tinx = 0; tinx < todoList.length; tinx++) {
        if (todoList[tinx].chargerId === this.userInfo.userId) {
          return todoList[tinx];
        }
      }
      return "";
    },
    clickMemberSearchBtn() {
      document.getElementById("todoTargetInput").value = "";
      this.isSearch = false;
    },
    searchByKeyword(event) {
      this.errorTarget = false;
      let obj = this;
      if (event.target.value.length > 1) {
        event.target.parentElement.classList.add("active");
        this.isSearch = true;
        let reqData = {};
        reqData.req = {
          searchKeyword: event.target.value,
        };
        reqData.url = "/api/auth/org/searchByUserName";
        reqData.method = "post";

        obj
          .COWORK_REST_ACTION(reqData)
          .then(function (data) {
            obj.userList = data.result;
            setTimeout(obj.updateUserPhoto, 500);
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        event.target.parentElement.classList.remove("active");
        obj.userList = [];
        this.isSearch = false;
      }
    },
    searchByKeyword1(event) {
      let obj = this;
      if(obj.searchFlag == false) {
        obj.searchFlag = true;
        return;
      }
      this.todoInfo.todoRegUser = null;
      if (event.target.value.length > 1) {
        this.isSearch1 = true;
        let reqData = {};
        reqData.req = {
          searchKeyword: event.target.value,
        };
        reqData.url = "/api/auth/org/searchByUserName";
        reqData.method = "post";

        obj
          .COWORK_REST_ACTION(reqData)
          .then(function (data) {
            obj.userList1 = data.result;
            setTimeout(obj.updateUserPhoto, 500);
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        obj.userList1 = [];
        this.isSearch1 = false;
      }
    },
    fnTodoAddMember(param) {
      let members = this.todoInfo.members;
      let isMemeberFlag = false;
      members.forEach((element, index) => {
        if (element.userId === param.userId) {
          isMemeberFlag = true;
        }
      });
      if (!isMemeberFlag) {
        members.push(param);
      }
      this.todoInfo.members = members;
      //document.getElementById("todoTargetInput").value = "";
      this.todoTargetInput = "";

      let element = this.$el.querySelectorAll(
        ".v-btn.v-btn--contained.theme--light.v-size--default"
      );
      for (let i = 0; i < element.length; i++) {
        if (element[i].getAttribute("aria-expanded")) {
          element[i].click();
        }
      }
    },
    todoAddregUser(param) {
      this.todoInfo.todoRegUser = param.userId;
      this.regUserName = param.userName;
      this.isSearch1 = false;
    },
    todoSetuserId(param1, param2) {
      this.deciEditorData.userId = param1;
      document.getElementById(
        "opiTargetName-" + this.editorData.paperBlockId
      ).value = param2;
    },
    todoForMe() {
      this.errorTarget = false;
      if (this.forMe) {
        this.forMe = false;
        this.todoInfo.members = [];
        this.todoTarget = this.$i18nUtil.trans("message.placeholder.name","이름으로 검색");
        document.getElementById("todoTargetInput").disabled = false;
      } else {
        this.forMe = true;
        this.todoInfo.members = [
          { userId: this.userInfo.userId, userName: this.userInfo.userName },
        ];
        this.todoTarget = this.userInfo.userName;
        document.getElementById("todoTargetInput").disabled = true;
      }
    },
    linkedModalOpen() {
      const modalInfo = {
        name: "TodoLinkedModal",
        obj: this.$modal,
        component: TodoLinkedModal,
        width: "800px",
      //  height: "516px",
        userInfo: this.userInfo,
      };
      this.showModal(modalInfo);
    },
    linkedListModalOpen() {
      const modalInfo = {
        name: "TodoLinkedListModal",
        obj: this.$modal,
        component: TodoLinkedListModal,
        width: "800px",
        height: "495px",
        linkList: this.linkList,
      };
      this.showModal(modalInfo);
    },
    updateUserPhoto() {
      let list = this.$el.querySelectorAll("div.user-photo[data-user-id]");
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let elem = list[inx];
          let userId = elem.getAttribute("data-user-id");
          let img = elem.querySelector("img");
          this.HW_GET_USER_PHOTO({img, userId});
        }
      }
    },
    removeLink(param) {
      for (let index = 0; index < this.linkList.length; index++) {
        if (this.linkList[index].targetId === param) {
          this.linkList.splice(index, 1);
        }
      }
    },
    removeLink2(param) {
      for (let index = 0; index < this.linkList.length; index++) {
        if (this.linkList[index].targetId === param.modalParam) {
          this.linkList.splice(index, 1);
        }
      }
    },
    removeLinkConfirm(param) {
      this.showConfirmDialog(
        { width: "400px" },
        this.$i18nUtil.trans("title.dialog.notice","알림"),
        this.$i18nUtil.trans("AB081"),
        this.$i18nUtil.trans("button.terminateConn","연결 해제"),
        this.removeLink2,
        param,
        this.$i18nUtil.trans("button.dialog.cancel","취소")
      );
    },
	onResize() {
		var check_kor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // 한글체크
		let nameLen = this.regUserName
		this.resizeWidth = check_kor.test(nameLen) ? nameLen.length * 10 + 50 : nameLen.length * 10
	}
  },
};
</script>
<style scoped>
/* 지역스타일 (Vue 객체스타일) */
</style>
<style> /* 전역스타일은 사용하지 말아 주세요. (board.css 에 추가 후 퍼블에 요청해주세요) */ </style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/TodoAddModal.vue